// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ud-z","articleImagesWrap":"vd-z","articleImage":"wd-z","singleImage":"xd-z"};